import * as z from "zod";

export const getDefaultSenderAddressForTeam = {
  name: "getDefaultSenderAddressForTeam" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({ name: z.string(), email: z.string(), domain: z.string() }),
};
